// Shows the floating add-to-cart button once the main product form scrolls above the viewport,
// and forwards clicks to the main add button so variant, quantity and cart drawer behaviour match.
const floatingAdd = document.querySelector('[data-floating-add]');
const productForm = document.querySelector('[data-product-form]');

if (floatingAdd && productForm) {
  const update = () => {
    const rect = productForm.getBoundingClientRect();
    floatingAdd.hidden = !(rect.bottom < 0);
  };
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();

  floatingAdd.addEventListener('click', () => {
    const mainAdd = productForm.querySelector('button[name="add"]:not([disabled])');
    if (mainAdd) mainAdd.click();
  });
}
